// extracted by css-extract-rspack-plugin
var _1 = "days-PyVSHH";
var _2 = "times-j0iafV";
export { _1 as "days", _2 as "times" }
